import { createBrowserRouter, Navigate } from "react-router-dom";
import DefaultLayout from "./components/DefaultLayout.js";
import GuestLayout from "./components/GuestLayout.js";
import Dashboard from "./views/dashboard/Dashboard.js";
import Login from "./views/login/Login.js";
import NotFound from "./views/NotFound.js";
import Shoppers from "./views/shoppers/Shoppers.js";
import ShoppersEdit from "./views/shoppers/ShoppersEdit.js";
import ShoppersAdd from "./views/shoppers/ShoppersAdd.js";
import Agreements from "./views/agreements/Agreements.js";
import AgreementsEdit from "./views/agreements/AgreementsEdit.js";
import AgreementsAdd from "./views/agreements/AgreementsAdd.js";
import Professionals from "./views/professionals/Professionals.js";
import ProfessionalsEdit from "./views/professionals/ProfessionalsEdit.js";
import ProfessionalsAdd from "./views/professionals/ProfessionalsAdd.js";
import Customers from "./views/customers/Customers.js";
import CustomersAdd from "./views/customers/CustomersAdd.js";
import CustomersEdit from "./views/customers/CustomersEdit.js";
import Users from "./views/users/Users.js";
import UsersEdit from "./views/users/UsersEdit.js";
import UsersAdd from "./views/users/UsersAdd.js";
import ReportPaymentSchedulings from "./views/reports/ReportPaymentSchedulings.js";
import ReportsList from "./views/reports/ReportsList.js";
import ProntoAtendimentoProfessionals from "./views/prontoAtendimento/ProntoAtendimentoProfessionals.js";
import Partners from "./views/partners/Partners.js";
import PartnersEdit from "./views/partners/PartnersEdit.js";
import PartnersAdd from "./views/partners/PartnersAdd.js";
//import HomePage from "./views/posConsult/HomePage.js";
// import ProcedurePage from "./views/posConsult/ProcedurePage.js";
// import ExamSelectionPage from "./views/posConsult/ExamSelectionPage.js";
// import PartnerSelectionPage from "./views/posConsult/PartnerSelectionPage.js";
// import ConfirmationPage from "./views/posConsult/ConfirmationPage.js";
// import Payment from "./views/posConsult/Payment.js";
// import PaymentPage from "./views/posConsult/PaymentPage";
import DoctorTransfer from "./views/financial/DoctorTransfer.js";
import DoctorTransferItem from "./views/financial/DoctorTransferItem.js";
import DoctorTransferAdd from "./views/financial/DoctorTransferAdd.js";
import FinancialPage from "./views/financial/FinancialPage.js";
import CompanyTransfer from "./views/financial/CompanyTransfer.js";
import CompanyTransferItem from "./views/financial/CompanyTransferItem.js";
import CompanyTransferAdd from "./views/financial/CompanyTransferAdd.js";
// import ReportRevenueDistributionConsult from "./views/financial/ReportRevenueDistributionConsult.js";
// import ReportRevenueDistributionConsultItem from "./views/financial/ReportRevenueDistribuitionItemConsult.js";
// import ReportRevenueDistributionConsultAdd from "./views/financial/ReportRevenueDistribuitionAddConsult.js";
import ConsultTransfer from "./views/financial/ConsultTransfer.js";
import ConsultTransferItem from "./views/financial/ConsultTransferItem.js";
import ConsultTransferAdd from "./views/financial/ConsultTransferAdd.js";
import AttendantsTransfer from "./views/financial/AttendantsTransfer.js";

import ProceduresList from "./views/procedures/ProceduresList.js";
import ProceduresEdit from "./views/procedures/ProceduresEdit.js";

//Novo posConsult
import PosConsultPageHome from "./views/newPosConsult/PosConsultPageHome.js";
// import ProceduresModal from "./views/newPosConsult/components/ProceduresModal.js";
// import CancelModal from "./views/newPosConsult/components/CancelModal.js";
// import PartnerSelectionModal from "./views/newPosConsult/components/DoctorSelectionPage.js";
// import ConfirmationModal from "./views/newPosConsult/components/ConfirmationPage.js";
// import ScheduledProceduresModal from "./views/newPosConsult/components/ScheduledProceduresModal.js";
// import SchedulingPage from "./views/newPosConsult/components/SchedulingPage.js";
// import PatientCard from "./views/newPosConsult/components/PatientCard.js";
// import RescheduleModal from "./views/newPosConsult/components/RescheduleModal.js";
// import PaymentModal from "./views/newPosConsult/components/PaymentModal.js";
import Cashiers from "./views/newPosConsult/components/Cashiers.js";
//import Pharmacies from "./views/pharmacies/Pharmacies.js";
//import PharmaciesAdd from "./views/pharmacies/PharmaciesAdd.js";
//import PharmaciesEdit from "./views/pharmacies/PharmaciesEdit.js";
import Labs from "./views/labs/Labs.js";
import Settings from "./views/settings/Settings.js";

//import Receipt from "./views/posConsult/Receipt.js";
import Unauthorized from "./views/Unauthorized.js";
import ProtectedRoute from "./components/ProtectedRoute.js";

//Sessão para Agenda de Procedimentos
import PosConsultSchedule from "./views/schedule/Schedule.js";
import LGPDAuthorizationForm from "./views/authorization/LGPDAuthorizationForm.js";
import AttendancesList from "./views/attendances/AttendancesList.js";

const prontoAtendimento = [
  {
    path: "/prontoatendimento",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator"]}>
        <ProntoAtendimentoProfessionals />,
      </ProtectedRoute>
    ),
  },
];

// const posConsult = [
//   {
//     path: "/pos-consult-antigo",
//     element: (
//       <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
//         <HomePage />
//       </ProtectedRoute>
//     ),
//     children: [
//       { index: true, element: <ProcedurePage /> },
//       { path: "procedure", element: <ProcedurePage /> }, 
//       { path: "exam-selection", element: <ExamSelectionPage /> },
//       { path: "partner-selection", element: <PartnerSelectionPage /> },
//       { path: "confirmation", element: <ConfirmationPage /> },
//       { path: "payment", element: <Payment /> }, 
//       { path: "payments", element: <PaymentPage /> }, 
//       { path: "receipt", element: <Receipt /> }, 
//     ],
//   },
// ];

const posConsultNew = [
  {
    path: "/pos-consultorio",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
        <PosConsultPageHome />
      </ProtectedRoute>
    ),
    // children: [
    //   { index: true, element: <ProcedurePage /> },
    //   { path: "procedure", element: <ProcedurePage /> }, 
    //   { path: "exam-selection", element: <ExamSelectionPage /> }, 
    //   { path: "partner-selection", element: <PartnerSelectionPage /> }, 
    //   { path: "confirmation", element: <ConfirmationPage /> }, 
    //   { path: "payment", element: <Payment /> },
    //   { path: "payments", element: <PaymentPage /> }, 
    //   { path: "receipt", element: <Receipt /> },
    // ],
  },
  {
    path: "/pos-consultorio/caixa",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
        <Cashiers />
      </ProtectedRoute>
    ),
  },
];

const schedule = [
  {
    path: "/schedule",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
        <PosConsultSchedule />
      </ProtectedRoute>
    ),
  },
];

const attendances = [
  {
    path: "/attendances",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Receptionist"]}>
        <AttendancesList />
      </ProtectedRoute>
    ),
  },
];

const users = [
  {
    path: "/users",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <Users />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <UsersEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users/add",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <UsersAdd />
      </ProtectedRoute>
    ),
  },
];

const shoppers = [
  {
    path: "/shoppers",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <Shoppers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/shoppers/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <ShoppersEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/shoppers/add",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
        ]}>
        <ShoppersAdd />
      </ProtectedRoute>
    ),
  },
];

const partners = [
  {
    path: "/partners",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <Partners />
      </ProtectedRoute>
    ),
  },
  {
    path: "/partners/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <PartnersEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/partners/add",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <PartnersAdd />
      </ProtectedRoute>
    ),
  },
];

const customers = [
  {
    path: "/customers",
    element: <Customers />,
  },
  {
    path: "/customers/:id",
    element: <CustomersEdit />,
  },
  {
    path: "/customers/add",
    element: <CustomersAdd />,
  },
];

const professionals = [
  {
    path: "/professionals",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <Professionals />
      </ProtectedRoute>
    ),
  },
  {
    path: "/professionals/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <ProfessionalsEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/professionals/add",
    element: (
      <ProtectedRoute
        rolesAllowed={[
          "Administrator",
          "Finance",
          "OnSiteSupport",
          "OnlineSupport",
          "ProjectManager",
          "Receptionist",
        ]}>
        <ProfessionalsAdd />
      </ProtectedRoute>
    ),
  },
];

const agreements = [
  {
    path: "/agreements",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
        <Agreements />
      </ProtectedRoute>
    ),
  },
  {
    path: "/agreements/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
        <AgreementsEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/agreements/add",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
        <AgreementsAdd />
      </ProtectedRoute>
    ),
  },
];

const financial = [
  {
    path: "/financial",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <FinancialPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-medico",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <DoctorTransfer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-medico/:id",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <DoctorTransferItem />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-medico/novo",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <DoctorTransferAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-empresa",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <CompanyTransfer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-empresa/:id",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <CompanyTransferItem />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-empresa/novo",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <CompanyTransferAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-consulta",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <ConsultTransfer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-consulta/:id",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <ConsultTransferItem />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-consulta/novo",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <ConsultTransferAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/financial/repasse-atendentes",
    element: (
      <ProtectedRoute rolesAllowed={["Administrator", "Finance"]}>
        <AttendantsTransfer />
      </ProtectedRoute>
    ),
  },
];

const reports = [
  {
    path: "/reports",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
        <ReportsList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/paymentschedulings",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
        <ReportPaymentSchedulings />
      </ProtectedRoute>
    ),
  },
];

const procedures = [
  {
    path: "/procedures",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
          <ProceduresList />
        </ProtectedRoute>
    )
  },
  {
    path: "/procedures/:id",
    element: (
      <ProtectedRoute
        rolesAllowed={["Administrator", "Finance", "ProjectManager"]}>
          <ProceduresEdit />
        </ProtectedRoute>
    )
  }
]

// const pharmacies = [
//   {
//     path: "/pharmacies",
//     element: (
//       <Pharmacies />
//     )
//   },
//   {
//     path: "/pharmacies/add",
//     element: (
//       <PharmaciesAdd />
//     )
//   },
//   {
//     path: "/pharmacies/:id",
//     element: (
//       <PharmaciesEdit />
//     )
//   }
// ]

const labs = [
  {
    path: '/labs',
    element: (
      <Labs />
    )
  }
]

const settings = [
  {
    path: '/settings',
    element: (
      <Settings />
    )
  }
]

const router = createBrowserRouter([
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
    ]
      .concat(prontoAtendimento)
      .concat(users)
      .concat(shoppers)
      .concat(partners)
      .concat(customers)
      .concat(professionals)
      .concat(agreements)
      .concat(reports)
      .concat(partners)
      //.concat(posConsult)
      .concat(posConsultNew)
      .concat(schedule)
      .concat(financial)
      .concat(Cashiers)
      .concat(procedures)
      //.concat(pharmacies)
      .concat(labs)
      .concat(settings)
      .concat(attendances)
  },
  {
    path: "/",
    element: <GuestLayout />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: '/autorizacao/:hash',
    element: <LGPDAuthorizationForm />
  }
]);

export default router;
